import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { assetPath } from "../../utils/constants";

const ThankYouPopup = ({ showThankYouPopUp, setShowThankYouPopUp,from }) => {
  const navigate =  useNavigate()
  const handleClose = () => {
    setShowThankYouPopUp(false);
    if(from==="apply-loan"){
    navigate("/dashboard");
    }
  };
  return (
    <Dialog
      open={showThankYouPopUp}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "20px",
          padding: "20px",
        },
      }}
    >
      <DialogContent>
        {/* Flexbox Section */}
        <Box display="flex" alignItems="center" justifyContent="center">
          <Box display="flex" justifyContent="center">
            <img
              src={assetPath("ThankYouImage.png")}
              alt="ThankYouImage"
              style={{ maxWidth: "150px" }}
            />
          </Box>
        </Box>

        {/* Text Button */}
        <Box mt={1} display="flex" justifyContent="center">
          <Typography variant="h5" fontWeight="bold" sx={{ color: "#004AAD" }}>
            Thank You !
          </Typography>
        </Box>

        <Box mt={1} display="flex" justifyContent="center">
          <Typography
            sx={{ fontStyle: "italic", fontSize: "0.8rem", color: "#5A5A5A" }}
          >
           {from==="apply-loan"?"Your application has been submitted successfully.":"Your request has been received successfully."}
          </Typography>
        </Box>
        <Box mt={1} display="flex" justifyContent="center">
          <Typography
            fontWeight="bold"
            sx={{ fontStyle: "italic", fontSize: "0.7rem" }}
          >
            Our advisor will contact you within 30 minutes during business hours 
            using the details you provided
          </Typography>
        </Box>
        <Box mt={1} display="flex" justifyContent="center">
          <Typography
            fontWeight="bold"
            sx={{ fontStyle: "italic", fontSize: "0.6rem" }}
          >
            Need further assistance? You can also reach out to our support team
            anytime.
          </Typography>
        </Box>

        {/* Submit Button */}
        <Box mt={2} display="flex" justifyContent="center">
          <Button
            variant="contained"
            fullWidth
            sx={{
              maxWidth: "250px",
              backgroundColor: "#004AAD",
              textTransform: "none",
              padding: 1,
            }}
            onClick={() => handleClose()}
          >
            Okay
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ThankYouPopup;
